import LoadingScreen from "../Loading/LoadingScreen.tsx";
import { useUserQuery } from "../../hooks/useUserQuery";
import type { ReactElement } from "react";

const AdminRoute = ({ children }: any): ReactElement | null => {

  const { data: user, isLoading } = useUserQuery();

  if (isLoading) {
    return <LoadingScreen fullScreen={true} />;
  }

  if (!user) {
    // user is not authenticated
    window.location.pathname = "/login";
    return null;
  }

  if (!user.isAdmin) {
    // user is not an admin, redirect to news
    window.location.pathname = "/app/news";
    return null;
  }

  return children as ReactElement;
};

export default AdminRoute;
